import { useContext, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Box, Container } from '@mui/material';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import Grid from '@mui/material/Grid';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SttForm } from '../../../sporttia/SttForm';
import { getPath } from '../../Pages';
import { AppContext } from '../../../sporttia/AppContext';

export default function SCContact() {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const { id } = useParams();
    const [sc, setSC] = useState({
        phonePublic: '',
        emailPublic: '',
    });
    const [form, setForm] = useState<any>({});
    const [sent, _setSent] = useState(false);
    const navigate = useNavigate();

    /**
     * Load SC
     */
    const loadSC = () => {
        cxt.api('GET', `/scs/${id}`, {
            success: (r: any) => {
                setSC(r.sc);
            },
        });
    };

    /**
     * Send
     */
    const send = () => {
        cxt.api('POST', `/scs/${id}/messages`, {
            params: {
                text: form.text,
            },
            success: (_r: any) => {
                cxt.showMessage('S', t('messages.sent'));
                navigate(
                    getPath('scProfile', {
                        state: { id },
                    }),
                );
            },
        });
    };

    /**
     * Handle form
     */
    const handleForm = ({ name, value }: any) => {
        setForm({ ...form, [name]: value });
    };

    /**
     * Sport center changes
     */
    useEffect(() => {
        loadSC();
    }, [id]);

    /**
     * Init
     */
    useEffect(() => {
        if (cxt.user) {
            setForm({
                name: cxt.user?.name,
                email: cxt.user?.email,
                phone: cxt.user?.mobile,
            });
        }
    }, []);

    return (
        <Container maxWidth="md">
            <Paper>
                <Box p={2}>
                    <Typography variant="h4" gutterBottom>
                        {t('contact.title')}
                    </Typography>
                    <Divider />
                    <Box pt={2} pb={2}>
                        <Typography variant="subtitle1">
                            <Grid container direction="row" alignItems="center">
                                <PhoneIcon fontSize="large" />
                                <Box ml={1}>
                                    {t('view.contact.byPhone')}
                                    &nbsp;<b>{sc.phonePublic}</b>
                                </Box>
                            </Grid>
                        </Typography>
                        <Typography variant="subtitle1">
                            <Grid container direction="row" alignItems="center">
                                <EmailIcon fontSize="large" />
                                <Box ml={1}>
                                    {t('view.contact.byEmail')}
                                    &nbsp;<b>{sc.emailPublic}</b>
                                </Box>
                            </Grid>
                        </Typography>
                    </Box>
                    <Divider />
                    <Box pt={2} pb={2}>
                        <Typography variant="subtitle1">
                            <Grid container direction="row" alignItems="center">
                                <LiveHelpIcon fontSize="large" />
                                <Box ml={1}>{t('view.contact.byForm')}</Box>
                            </Grid>
                        </Typography>

                        <Box pt={2}>
                            <SttForm
                                onChangeForm={handleForm}
                                elements={[
                                    {
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                        caption: t('labels.name'),
                                        name: 'name',
                                        value: form.name,
                                    },
                                    {
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                        caption: t('labels.email'),
                                        name: 'email',
                                        value: form.email,
                                    },
                                    {
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                        caption: t('labels.phone'),
                                        name: 'phone',
                                        value: form.phone,
                                    },
                                    {
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                        type: 'textarea',
                                        name: 'text',
                                        caption: t(
                                            'view.contact.reportIncidenceOrConsults',
                                        ),
                                        value: form.text,
                                    },
                                ]}
                                buttons={[
                                    {
                                        type: 'accept',
                                        show: !sent,
                                        caption: t('general.send'),
                                        onClick: () => send(),
                                    },
                                ]}
                            />
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
}
